'use strict';

orderOverviewItem.$inject = ["Enums", "gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderOverviewItem = orderOverviewItem;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function orderOverviewItem(Enums, gettextCatalog) {
    var clazz = function OrderOverviewItem() {
        var defaults = {
            id: 0,
            referenceNumber: '',
            orderNumber: '',
            date: '',
            seller: '',
            amount: 0,
            orderStatusCode: '',
            isPartialStatus: false,
            orderStatusText: '',
            hasError: false,
            hasSuccess: false
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.referenceNumber = resource.referenceNumber;
        o.orderNumber = resource.orderNumber;
        o.date = resource.orderDate;
        o.seller = resource.sellerName;
        o.amount = resource.totalPriceWithDiscount;
        o.orderStatusCode = resource.stateCode;
        o.isPartialStatus = resource.isPartialState;
        o.deliveryDate = resource.deliveryDate;
        o.orderStatusText = orderStatusText(resource.stateCode);
        o.hasError = hasError(resource.stateCode);
        o.hasSuccess = hasSuccess(resource.stateCode);
        return o;
    };

    function orderStatusText(code) {
        return code ? gettextCatalog.getString(Enums.orderStatusTexts[code].text) : '';
    }

    function hasError(code) {
        return code ? code === 'ERROR' || code === 'CANCELLED' : false;
    }

    function hasSuccess(code) {
        return code ? code === 'READYWS' || code === 'INVWS' || code === 'INVWSP' : false;
    }

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/orderOverviewItemModel.js
// module id = 764
// module chunks = 0